import * as THREE from "three";
import { ChannelVisualizationFragmentShader } from "../../materials/shaders/ChannelVisualizationFragmentShader";
import { UVVertexShader } from "./UVVertexShader";

/**
 * @returns A material that copies whatever is in the GBA channels of map, and sets the alpha channel to 1.
 */
export function materialShowAONormals(): THREE.ShaderMaterial {
  return new THREE.ShaderMaterial({
    uniforms: {
      map: { value: null },
      channels: { value: [1, 2, 3, -1] },
    },
    vertexShader: UVVertexShader,
    fragmentShader: ChannelVisualizationFragmentShader,
    depthTest: false,
    depthWrite: false,
    blending: THREE.CustomBlending,

    blendSrc: THREE.OneFactor,
    blendDst: THREE.ZeroFactor,

    blendSrcAlpha: THREE.OneFactor,
    blendDstAlpha: THREE.OneFactor,
    blendEquationAlpha: THREE.AddEquation,
    name: "aoDebug materialShowAONormals",
  });
}

/**
 * @returns A material that multiplies the colors in the destination framebuffer with the red channel of map.
 */
export function materialMultiplyByRed(): THREE.ShaderMaterial {
  return new THREE.ShaderMaterial({
    uniforms: {
      map: { value: null },
      channels: { value: [0, 0, 0, -1] },
    },
    vertexShader: UVVertexShader,
    fragmentShader: ChannelVisualizationFragmentShader,
    transparent: true,
    depthTest: false,
    depthWrite: false,
    blending: THREE.MultiplyBlending,
    name: "aoDebug materialMultiplyByRed",
  });
}
